import { CognitoUserPool, ICognitoStorage } from 'amazon-cognito-identity-js';
import Amplify, { Auth } from 'aws-amplify';

import { getConfigValue } from '../environment';

import storageSync from './storage';

/**
 * @class
 * The cognito class provides helper methods for configuring and interacting
 * with cognito services
 */
export class Cognito {
  public static storage: ICognitoStorage = storageSync as ICognitoStorage;

  private static userPoolEndpoint() {
    const region = getConfigValue('aws').region;
    return `https://cognito-idp.${region}.amazonaws.com/`;
  }

  public static userPool() {
    const { userPoolClientId, userPoolId } = getConfigValue('aws');

    return new CognitoUserPool({
      UserPoolId: userPoolId,
      ClientId: userPoolClientId,
      endpoint: Cognito.userPoolEndpoint(),
      Storage: storageSync as ICognitoStorage,
    });
  }

  public static configure() {
    const { userPoolClientId, userPoolId } = getConfigValue('aws');
    Auth.configure({
      userPoolId,
      userPoolWebClientId: userPoolClientId,
      endpoint: Cognito.userPoolEndpoint(),
      storage: storageSync,
    });

    Amplify.configure({ disabled: true });
  }
}

export default Cognito;
